// extracted by mini-css-extract-plugin
module.exports = {"OpportunitySidebar":"_2sLrxu-e","hidden":"_38oV6J4z"};